import MonitorPage from '@/pages/monitor/layout'
import MonitorIndexPage from '@/pages/monitor/index'
import ProgressbARIndexPage from '@/pages/monitor/progress'

const routes = {
	path: '/monitor',
	component: MonitorPage,
	meta: {title: 'Мониторинг', breadcrumb: 'Мониторинг'},
	children: [
		{
			path: '',
			component: MonitorIndexPage,
			meta: {title: 'Мониторинг'}
		},
		{
			path: 'progress',
			component: ProgressbARIndexPage,
			meta: {title: 'Живой монитор'}
		}
	]
}

export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/monitor.js